module.exports = __webpack_public_path__ + "static/media/facebookIcon.0735ae2c.svg";